import React, { useContext, useEffect, useState } from 'react';
import DataTable from "react-data-table-component";
import axiosIntance from '../../../config/axios'
import { RootContext } from '../../../App';
import refactorStructureData from '../../../helpers/refactorDataMenu';
import { Card, CardBody, CardHeader } from "@material-tailwind/react";
import Swal from "sweetalert2";

const NewAdminRole = () => {

    const [data , setData] = useState([])
    const [pending , setPending] = useState(true)
    const [menuid, setMenuid] = useState([]);
    const [rolename, setRolename] = useState("");
    const [desc, setDesc] = useState("");
    const token = localStorage.getItem("access_token")
    const group = JSON.parse(localStorage.getItem("group"))
    const {state , setState} = useContext(RootContext)

    function handleSave() {

        // console.log("handle save")
        // console.log("role name: ", rolename)
        // console.log("menu list: ", menuid.join())

        if(menuid.length === 0 || rolename === "") {

            Swal.fire("Can't Empty", 'Fill role name, and menu list', 'warning')
        }else{

            axiosIntance.post('create_admin_role' , {
                token: token,
                group: group.wbid,
                rolename: rolename,
                menulist: menuid,
                desc: desc
                }).then((res)=>{

                    if(res.data.code === 0) {
                        
                        Swal.fire("Success", 'New Admin Role Created', 'success').then(() => {

                            window.location.replace("/admin/role")
                        })
                    }else{

                        Swal.fire("Internal Error", 'Internal Server Error', 'error')
                    }
                    /* setPending(false)
                    setData(res.data.data.list)
                    setState({
                        ...state,
                        group: res.data.data.additional_data.group,
                        menu: refactorStructureData(res.data.data.additional_data.menu),
                    }) */
                })
        }
    }

    useEffect(()=>{
        axiosIntance.post('get_menu_list' , {
        token :token ,
        group :group.wbid
        }).then((res)=>{

            console.log("list data: ", res.data.data.list)
            setPending(false)
            setData(res.data.data.list)
            setState({
                ...state,
                group: res.data.data.additional_data.group,
                menu: refactorStructureData(res.data.data.additional_data.menu),
            })
        })
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    const columns = [
        {
            name: "Menu Root",
            selector: (row) => row.menu_root ? row.menu_root : "Not Found",
            sortable: false,
        },
        {
            name: "Menu Name",
            selector: (row) => row.menu_name ? row.menu_name : "Not Found",
            sortable: false,
        },
        {
            name: "Description",
            selector: (row) => {
                let desc = row.description ? row.description : ""
                return desc;
            },
            sortable: false,
        },
        {
            name: "Add To Role",
            selector: (row) => {
                return <input type="checkbox" value={row.mn_id} className="appearance-none h-5 w-5 border border-gray-300 rounded-md checked:bg-blue-600 checked:border-transparent focus:outline-none" onChange={(e) => {

                    console.log("this checkbox value are: ", e.target.value)
                    const newArray = menuid

                    const index = newArray.indexOf(e.target.value);

                    // Check if the value was found (indexOf returns -1 if not found)
                    if (index > -1) {

                        // Remove one element starting at the found index
                        newArray.splice(index, 1);

                        setMenuid(newArray)
                    }else{

                        console.log("New Array: ", newArray)

                        newArray.push(e.target.value)

                        setMenuid(newArray)
                    }
                }} />
            },
            sortable: false,
        },
        
    ]

  return (
    <Card>
        <CardHeader color="blueGray" contentPosition="left">
            <h2 className="text-white text-2xl">Add New Role</h2>
        </CardHeader>
        <div className='w-full h-20 flex items-center px-4 gap-4'>
            <div className='w-60 h-11 bg-white rounded-lg border-2 border-sky-500 border-solid'>
                <input type='text' className='w-full h-full rounded-lg text-center px-4' placeholder='Role Name' onChange={(e) => {

                    setRolename(e.target.value)
                }} />
            </div>
            <div className='w-[450px] h-11 bg-white rounded-lg border-2 border-sky-500 border-solid'>
                <input type='text' className='w-full h-full rounded-lg text-center px-4' placeholder='Description' onChange={(e) => {

                    setDesc(e.target.value)
                }} />
            </div>
            <div className='w-full'>

            </div>
            <button className='w-40 h-11 rounded-lg bg-green-500 hover:bg-green-600 text-white' onClick={handleSave}>
                Save
            </button>
        </div>
        <CardBody >
            <div className='w-full h-auto border-2 border-gray-800 border-solid rounded-md flex flex-col'>
                <div className='w-full h-20 bg-gray-600 px-10 flex items-center'>
                    <div className='text-[24px] text-white'>
                        Menu List
                    </div>
                </div>
                <DataTable
                    columns={columns}
                    data={data}
                    progressPending={pending}
                />
            </div>
        </CardBody>
    </Card>
  )
}

export default NewAdminRole